export default __webpack_public_path__ + "static/media/oasis-frontdoor.ebd799fd.png";